"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordSetNewPasswordResponseToJSON = exports.ForgotPasswordSetNewPasswordResponseFromJSONTyped = exports.ForgotPasswordSetNewPasswordResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ForgotPasswordSetNewPasswordResponseFromJSON(json) {
    return ForgotPasswordSetNewPasswordResponseFromJSONTyped(json, false);
}
exports.ForgotPasswordSetNewPasswordResponseFromJSON = ForgotPasswordSetNewPasswordResponseFromJSON;
function ForgotPasswordSetNewPasswordResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'setNewPasswordResult': (0, _1.ForgotPasswordSetNewPasswordResultFromJSON)(json['setNewPasswordResult']),
        'loginResult': !(0, runtime_1.exists)(json, 'loginResult') ? undefined : (0, _1.ChangeCustomerResultWithTokensFromJSON)(json['loginResult']),
    };
}
exports.ForgotPasswordSetNewPasswordResponseFromJSONTyped = ForgotPasswordSetNewPasswordResponseFromJSONTyped;
function ForgotPasswordSetNewPasswordResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'setNewPasswordResult': (0, _1.ForgotPasswordSetNewPasswordResultToJSON)(value.setNewPasswordResult),
        'loginResult': (0, _1.ChangeCustomerResultWithTokensToJSON)(value.loginResult),
    };
}
exports.ForgotPasswordSetNewPasswordResponseToJSON = ForgotPasswordSetNewPasswordResponseToJSON;
//# sourceMappingURL=ForgotPasswordSetNewPasswordResponse.js.map